var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"playView"}},[_c('iframe',{attrs:{"id":"playIframe","title":"CareGame","src":_vm.playUrl,"width":"100%","height":"100%","frameborder":0,"scrolling":'no',"allowfullscreen":true}})])}
var staticRenderFns = []

export { render, staticRenderFns }